import React, { useState, useEffect } from 'react';

interface AboutDialogProps {
  onClose: () => void;
}

const AboutDialog: React.FC<AboutDialogProps> = ({ onClose }) => {
  const [pv, setPv] = useState<string>('');
  const [uv, setUv] = useState<string>('');

  useEffect(() => {
    // Read the PV and UV counts from the hidden spans populated by vercount.one
    const pvEl = document.getElementById('busuanzi_value_page_pv');
    const uvEl = document.getElementById('busuanzi_value_page_uv');
    if (pvEl || uvEl) {
      // vercount.one may populate spans asynchronously, so poll briefly
      const check = () => {
        let ready = true;
        if (pvEl) {
          const text = pvEl.textContent?.trim();
          if (text) setPv(text); else ready = false;
        }
        if (uvEl) {
          const text = uvEl.textContent?.trim();
          if (text) setUv(text); else ready = false;
        }
        return ready;
      };
      if (!check()) {
        const timer = setTimeout(() => check(), 500);
        return () => clearTimeout(timer);
      }
    }
  }, []);

  return (
    <div
      className="fixed inset-0 bg-black/50 z-[60] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl p-6 w-full max-w-xs shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center mb-5">
          <div className="w-16 h-16 bg-[#3B82F6] rounded-2xl flex items-center justify-center mx-auto mb-3">
            <span className="text-white text-2xl font-bold">字</span>
          </div>
          <h2 className="text-xl font-bold text-gray-800">汉字练字助手</h2>
          <p className="text-sm text-gray-500 mt-1">v1.0.0</p>
        </div>

        <div className="space-y-3 text-sm text-gray-600">
          <p>一个简洁的汉字字帖生成工具，支持自定义格线（田字格、米字格等）和字体，帮助您练习汉字书写。</p>
          <p>可联网下载的都是免费字体（如有版权字体肯请告知），首次使用后将会缓存到本地。</p>
          <p>也可以自行下载喜欢的字体文件到本地，从菜单“添加字体”进行使用。</p>
          
          <div className="border-t border-gray-100 pt-3">
            <p className="text-xs text-gray-400">
              作者：<a href="mailto:yanggq@aliyun.com">Stoney Yang</a>
            </p>
            <p className="text-xs text-gray-400">
              许可：MIT License
            </p>
            <p className="text-xs text-gray-400 mt-2">
              访问量：{pv || '0'}次  {uv ? `${uv} 人` : ''}
            </p>
          </div>
        </div>

        <button
          onClick={onClose}
          className="mt-5 w-full py-2.5 bg-[#3B82F6] text-white rounded-lg hover:bg-blue-600 transition text-sm font-medium"
        >
          确定
        </button>
      </div>
    </div>
  );
};

export default AboutDialog;
